import type { ISO8601 } from "../../utils/iso8601";

export const shortDate = (date: ISO8601): string => {
  const value = new Date(date);
  return `${value.getDate()} ${value.toLocaleString("en-US", { month: "short" })} ${value.getFullYear()}`;
};
